import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base';
import {  InjectLocationInJobRequest } from '../../domain';
import { JobsRepository } from '../../repositories';


@Injectable({ providedIn: 'root' })
export class InjectLocationJobUsecase implements UseCase<InjectLocationInJobRequest,boolean> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(params: InjectLocationInJobRequest): Observable<boolean> {
    return this.jobRepository.injectLocationInJobs(params);
  }

}
